import type {ValueOf} from '~/types/value-of'

export const analyticsPageTab = {
  user: 'user',
  network: 'network',
  token: 'token',
  marketplace: 'marketplace'
} as const
export type analyticsPageTab = ValueOf<typeof analyticsPageTab>


export default {
  getAnalyticsPage: (tab?: analyticsPageTab) => {
    if (!tab) {
      tab = analyticsPageTab.user
    }
    return `/analytics/${tab}`
  },
  getChartPage: (chartName: string) => {
    return `/analytics/chart/${chartName}`
  }
}